<template>
	<div>
		<el-row class="head">
			<el-col :xs="5" :sm="5" :md="4" :lg="4" :xl="4">
				<el-col :span="1">
					<span @click="$router.push('/')">
						<img src="../../assets/img/logo.png" alt="">
					</span>
					<span class="p400">
						4008003135
					</span>
				</el-col>
			</el-col>
			<el-col :xs="10" :sm="10" :md="12" :lg="12" :xl="14" class="custom-col-14">
				<span style="font-weight:bold;margin-left:5px;overflow: hidden;white-space: nowrap;">
					致力于为工业电气自动化元器件行业滞纳库存解决方案做加速服务
				</span>
			</el-col>
			<el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" v-if="!info">
				<el-badge @click="chat_click()" :value="$chat.state.chatnum ? $chat.state.chatnum : ''" class="item">
					<span>消息</span>
				</el-badge>
			</el-col>
			<!-- <el-col :span="2" class="information">
				<el-icon class="Bell" style="vertical-align: middle;"><Bell /></el-icon>
				<span style="vertical-align: middle;">消息</span>
				<el-icon style="vertical-align: middle;"><CaretBottom /></el-icon>
			</el-col> -->
			<el-col :xs="4" :sm="4" :md="3" :lg="3" :xl="2" v-if="!info">
				<el-row>
					<el-col :span="24">
						<span v-if="user_id">
							<!-- @click="$router.push('/user')"  -->
							<el-dropdown @command="handleCommand">
								<span class="el-dropdown-link">
									<el-badge
										:value="($globalData.to_report_num + $globalData.to_edit_num) ? ($globalData.to_report_num + $globalData.to_edit_num) : ''"
										class="item">
										{{ mobile }}
									</el-badge>
									<el-icon class="el-icon--right">
										<arrow-down />
									</el-icon>
								</span>
								<template #dropdown>
									<el-dropdown-menu>
										<el-dropdown-item command="3">个人中心</el-dropdown-item>
										<el-dropdown-item command="4">库存中心</el-dropdown-item>
										<el-dropdown-item command="6">我的订单</el-dropdown-item>
										<!-- <el-dropdown-item command="7">销售订单</el-dropdown-item> -->
										<el-dropdown-item command="5">
											<el-badge
												:value="($globalData.to_report_num + $globalData.to_edit_num) ? ($globalData.to_report_num + $globalData.to_edit_num) : ''"
												class="item">
												反馈列表
											</el-badge>
										</el-dropdown-item>
										<!-- <el-dropdown-item command="6">关于我们</el-dropdown-item> -->
										<el-dropdown-item command="2">退出登录</el-dropdown-item>
									</el-dropdown-menu>
								</template>
							</el-dropdown>
						</span>
						<span v-else>
							<span @click="$router.push('/login')">
								登录
							</span>
							<span @click="$router.push('/register')">
								注册
							</span>
						</span>
					</el-col>
				</el-row>
			</el-col>
			<el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="1" v-if="user_id" class="custom-col-1">
				<span @click="$router.push({ path: '/user', query: { type: 'purchase' } })"
					style="font-weight:bold;color:rgba(255, 138, 92)">新手教程</span>
			</el-col>
			<el-col :span="2">
				<span>
					<el-tooltip placement="top" effect="light">
						<template #content>
							<el-row style="text-align:center">
								<el-col :span="24">
									<el-row>
										<el-col :span="24">
											<span>
												<img src="../../assets/img/qr2.png" alt="" style="width:100px"
													class="code">
											</span>
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</template>
						下载中心
					</el-tooltip>
				</span>
			</el-col>
		</el-row>
		<el-row class="logo_m"
			v-if="$route.path != '/login' && $route.path != '/register' && $route.path != '/forgetPassword'">
			<el-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 24, offset: 0 }" :md="{ span: 22, offset: 1 }"
				:lg="{ span: 22, offset: 1 }" :xl="{ span: 18, offset: 3 }" class="custom-col-20 offset-col-2">
				<el-row>
					<el-col :xs="10" :sm="10" :md="8" :lg="7" :xl="5" class="custom-col-5">
						<div @click="$router.push('/')" class="logo_m_img">
							<img src="../../assets/img/1.png" alt="">
						</div>
					</el-col>
					<el-col :xs="14" :sm="14" :md="15" :lg="16" :xl="18" class="Search custom-col-18">
						<el-input v-model="filter" @keydown.enter="search" @input="filterInput" style="height: 40px;"
							placeholder="品牌、品名、型号、订货号、空白也可搜索全部">
							<template #prepend>
								<el-popover destroy-on-close ref="popoverRef" :width="popoverWidth" trigger="click"
									placement="bottom-start" popper-class="filter-popover" @show="onPopoverShow">
									<template #reference>
										<el-button type="default"
											style="height: 40px; border-radius: 4px 0 0 4px; border-right: none;">
											<el-badge :value="selectedBrandCount" v-if="selectedBrandCount > 0" class="filter-badge">
											<span>筛选</span>
										</el-badge>
											<span v-else>筛选</span>
											<el-icon style="margin-left: 4px;">
												<ArrowDown />
											</el-icon>
										</el-button>
									</template>
									<div class="filter-content">
										<el-row v-for="(group, index) in stock_type" :key="index" class="filter-row"
											v-show="group.label">
											<el-col :span="2" class="filter-label">
												<span>{{ group.label }}</span>：
											</el-col>
											<el-col :span="22" class="filter-options">
												<span v-if="group.label === '货物类型'">
													<span v-for="(item, index) in group.options">
														<el-button :key="item.value"
															:type="select.includes(item.value) ? 'primary' : 'default'"
															:plain="!select.includes(item.value)"
															@click="handleOptionClick(item.value, group.isSingle)"
															class="filter-btn">
															<span v-html="renderColoredText(item.value)"></span>
														</el-button>
														<br v-if="index == 3">
													</span>

												</span>
												<span v-else-if="group.label === '品牌'">
													<div v-loading="brandLoading" element-loading-text="加载中..."
														style="min-height: 60px;">
														<span style="margin-left: 0.2rem;"
															v-for="item in (brandShowAll ? group.options : group.options.slice(0, brandShowCount))"
															:key="item.value">
															<el-button
																:type="select.includes(item.value) ? 'primary' : 'default'"
																:plain="!select.includes(item.value)"
																@click="handleOptionClick(item.value, group.isSingle)"
																class="filter-btn">
																{{ item.label ? item.label : item.value }}
															</el-button>
														</span>
														<span v-if="group.options.length > brandShowCount"
															style="font-size: 12px; cursor: pointer; color: #409eff; margin-left: auto; margin-top: 8px;"
															@click="brandShowAll = !brandShowAll">
															{{ brandShowAll ? '收起' : '查看全部' }}
														</span>
													</div>
												</span>
												<span v-else>
													<span style="margin-left: 0.2rem;" v-for="item in group.options">

														<el-button :key="item.value"
															:type="select.includes(item.value) ? 'primary' : 'default'"
															:plain="!select.includes(item.value)"
															@click="handleOptionClick(item.value, group.isSingle)"
															class="filter-btn">
															{{ item.label ? item.label : item.value }}
														</el-button>
													</span>

												</span>

											</el-col>
										</el-row>
										<el-row class="filter-actions">
											<el-col :span="24" style="text-align: right;">
												<el-button @click="handleReset" class="reset-btn">重置</el-button>
												<el-button type="primary" @click="handleConfirm"
													class="confirm-btn">确定</el-button>
											</el-col>
										</el-row>
										<el-row style="display: none;">
											<el-col :span="24">
												{{ selectedGoodsType.join(',') }}
											</el-col>
										</el-row>
									</div>
								</el-popover>
							</template>
							<template #append>
								<el-button @click="search" type="primary" class="button" style="width:80px;">
									<el-icon color="#fff" size="18px" class="no-inherit">
										<Search />
									</el-icon>
								</el-button>
							</template>
						</el-input>
					</el-col>
				</el-row>
			</el-col>
			<!-- <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="3" :offset="1">
				<el-row style="">
					<el-col :span="24" class="accounts">
						<el-row justify="center">
							<el-col :span="24">
								公众号
							</el-col>
							<el-col :span="24">
								<span>
									<img src="../../assets/img/qr2.png" alt="" class="code">
								</span>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</el-col> -->
		</el-row>
		<chat ref="chat" v-if="chat_info" v-on:closeChat="closeChat($event)"></chat>
	</div>
</template>
<script>
import '../../assets/index.css' //优化表格样式
import { ElMessage, ElMessageBox } from 'element-plus'
import chat from '../public/chat';
import { ArrowDown } from '@element-plus/icons-vue'
export default {

	components: {
		chat,
		ArrowDown,
	},
	data() {

		return {
			screenSize: 'xl',
			stock_type: [{
				label: '图片类型',
				isSingle: false, // ✅ 新增：标记为【单选】
				options: [
					{ value: '1', label: '有图' },
					{ value: '2', label: '无图' },
				],
			},
			{
				label: '是否核实',
				isSingle: false, // ✅ 修改为【多选】
				options: [
					
					{ value: '10', label: '平台认证' },
					{ value: '9', label: '用户自营' },
				],
			},
			{
				label: '品牌',
				isSingle: false, // ✅ 多选类型
				options: [],
			},
			{
				label: '货物类型',
				isSingle: false, // ✅ 新增：标记为【多选】
				options: [
					{ text: '滞纳、在保、包附完好', value: '滞纳、在保、包附完好' },
					{ text: '滞纳、在保、包附破损', value: '滞纳、在保、包附破损' },
					{ text: '滞纳、过保、包附完好', value: '滞纳、过保、包附完好' },
					{ text: '滞纳、过保、包附破损', value: '滞纳、过保、包附破损' },
					{ text: '二手、在保、包附完好', value: '二手、在保、包附完好' },
					{ text: '二手、在保、包附破损', value: '二手、在保、包附破损' },
					{ text: '二手、过保、包附完好', value: '二手、过保、包附完好' },
					{ text: '二手、过保、包附破损', value: '二手、过保、包附破损' },
				],
			},
			{
				label: '订货号',
				isSingle: false, // ✅ 新增：标记为【单选】
				options: [
					
					{ value: '4', label: '精确筛选' },
					{ value: '3', label: '疑似筛选' },
				],
			},
			{
				label: '型号',
				isSingle: false, // ✅ 新增：标记为【单选】，
				options: [
					
					{ value: '8', label: '精确筛选' },
					{ value: '5', label: '疑似筛选' },
				],
			},


			{
				label: '',
				isSingle: true, // ✅ 新增：标记为【单选】，
				options: [
					{ value: '6', label: '重置' },
				],
			},
			{
				label: '',
				isSingle: true, // ✅ 新增：标记为【单选】，
				options: [
					{ value: '7', label: '保存' },
				],
			},
			],

			select: ['1','2','3', '5', '9', '10', 'brand_siemens', 'brand_schneider', 'brand_abb'],
			selectedGoodsType: [],
			img_info: '',
			chat_info: false,
			filter: '',
			user_id: '',
			username: '',
			mobile: '',
			brandShowAll: false,
			brandShowCount: 38,
			brandLoading: false,
		}
	},
	props: ['info'],

	updated() {
		this.updateScreenSize();
	},
	computed: {
		popoverWidth() {
			const widthMap = {
				xs: '90vw',
				sm: '90vw',
				md: '800px',
				lg: '1000px',
				xl: '1120px'
			};
			return widthMap[this.screenSize] || '1120px';
		},
		selectedBrandCount() {
			const brandGroup = this.stock_type.find(item => item.label === '品牌');
			if (!brandGroup || !brandGroup.options) return 0;
			const brandValues = brandGroup.options.map(opt => opt.value);
			return this.select.filter(val => brandValues.includes(val)).length;
		}
	},
	watch: {

	},

	mounted() {
		this.$chat.on('chat-message', this.handleMessage);
		//this.updateScreenSize();
		//window.addEventListener('resize', this.updateScreenSize);
	},

	activated() {
		this.user_id = localStorage.getItem('user_id');
		this.username = localStorage.getItem('username');
		this.mobile = localStorage.getItem('mobile');


	},
	beforeUnmount() {
		// 组件卸载时取消监听
		this.$chat.off('chat-message', this.handleMessage);
		//window.removeEventListener('resize', this.updateScreenSize);
	},

	created() {
		this.filter = this.$route.query.filter
		if (this.$route.query.stock_type) {
			this.select = this.$route.query.stock_type.split(',')
		} else {
			if (this.$route.query.stock_type === '') {
				this.select = []
			} else {
				this.select = ['1','2','3', '5', '4', '8', '9', '10']
			}
		}

		this.user_id = localStorage.getItem('user_id');
		this.username = localStorage.getItem('username');
		this.mobile = localStorage.getItem('mobile');
		this.getchatnum()
		this.getBrandOptions()


	},

	methods: {
		updateScreenSize() {
			const width = window.innerWidth;
			if (width < 768) {
				this.screenSize = 'xs';
			} else if (width < 992) {
				this.screenSize = 'sm';
			} else if (width < 1200) {
				this.screenSize = 'md';
			} else if (width < 1920) {
				this.screenSize = 'lg';
			} else {
				this.screenSize = 'xl';
			}
		},
		chat_click() {
			this.chat_info = false;
			this.$nextTick(() => {
				this.chat_info = true;
				this.$nextTick(() => {
					this.$refs['chat'].dialogTableVisible = true;
					this.$refs['chat'].admin_pitch_id = ''; //维护一个不变的数据 这个需要告诉后台是从哪里点进来的
					this.$nextTick(() => {
						this.$refs['chat'].search()
					})
				})
			})
		},
		closeChat() {
			this.chat_info = false;
		},
		//第一次连接成功
		handleMessage(message) {
			if (message.type == 'init') {
				this.bind(message.client_id);
			} else if (message.type == 'say') {
				//接受到消息请求下未读数量
				this.getchatnum()
			}
		},
		async getchatnum() {
			if (!localStorage.getItem('user_id')) {
				return false
			}
			await this.$axios.post('/api/yunsys.Chat/getchatnum').then(async (res) => {
				var res = res.data;
				this.$chat.state.chatnum = res.data
				console.log(this.$chat.state.chatnum, 211)
			})
				.catch(err => {

				})
		},
		async bind(client_id) {
			if (!localStorage.getItem('user_id')) {
				return false
			}
			localStorage.setItem('client_id', client_id)
			await this.$axios.post('/api/yunsys.Chatroom/bind', { client_id }).then(async (res) => {
				var res = res.data;

			})
				.catch(err => {

				})
		},
		handleCommand(val) {
			if (val == 2) {
				ElMessageBox.confirm(
					'确认退出登录！',
					'提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
				}
				)
					.then(() => {
						localStorage.removeItem('token')
						localStorage.removeItem('lead_id')
						localStorage.removeItem('user_id')
						localStorage.removeItem('username')
						localStorage.removeItem('mobile')
						this.$router.push('/login');
						return false
					})
					.catch(() => {

					})
			} else if (val == 1) {
				//this.$router.push({ path: '/search', query: { filter: this.filter } });
			} else if (val == 3) {
				this.$router.push({ path: '/user', query: { type: 'userinfo' } });
			} else if (val == 4) {
				this.$router.push({ path: '/user', query: { type: 'publish' } });
			} else if (val == 5) {
				this.$router.push({ path: '/user', query: { type: 'tuoshou' } });
			} else if (val == 6) {
				this.$router.push({ path: '/user', query: { type: 'orderList' } });
			} else if (val == 7) {
				this.$router.push({ path: '/user', query: { type: 'market' } });
			}
		},
		filterInput() {
			if (this.$route.path == '/search') {
				console.log(this.select)
				// 将数组转为字符串，用逗号分隔（可自定义分隔符，如 '|' 等）
				const selectStr = this.select ? this.select.join(',') : '';


				this.$router.replace({
					query: {
						filter: this.filter,
						stock_type: selectStr, // 传入转换后的字符串
					}
				});
			} else {

			}
		},
		async getBrandOptions() {
			if (this.brandLoading) return;
			this.brandLoading = true;
			await this.$axios.post('/api/yunsys.Storage/getParams').then(res => {
				var res = res.data;
				if (res.data && res.data.length > 0) {
					const brandGroup = this.stock_type.find(item => item.label === '品牌');
					if (brandGroup) {
						brandGroup.options = res.data.map(item => ({
							value: item.brand_name,
							label: item.brand_name
						}));
					}
				}
			}).catch(err => {

			}).finally(() => {
				this.brandLoading = false;
			})
		},
		onPopoverShow() {
			this.getBrandOptions();
		},
		handleSelectChange(newSelectedValues) {
			// ============ 新增：重置按钮的清空核心逻辑 start ============
			// 判断本次选中的值中，是否包含 重置的value = '6'
			if (!newSelectedValues || newSelectedValues.length === 0) {
				this.select = [];
				this.filterInput();
				return;
			}
			let finalSelected = [];
			this.stock_type.forEach(item => {
				const typeValues = item.options.map(opt => opt.value);
				const currentSelected = newSelectedValues.filter(val => typeValues.includes(val));
				if (currentSelected.length === 0) return;

				if (item.isSingle) {
					finalSelected.push(currentSelected.pop());
				} else {
					finalSelected.push(...[...new Set(currentSelected)]);
				}
			});
			this.select = finalSelected;
			this.filterInput();
		},
		// 处理选项点击
		handleOptionClick(value, isSingle) {
			// 先检查当前选项是否已选中
			const isSelected = this.select.includes(value);

			if (isSingle) {
				// 单选：先移除同组的其他选项
				const group = this.stock_type.find(g => g.options.some(o => o.value === value));
				if (group) {
					const groupValues = group.options.map(o => o.value);
					this.select = this.select.filter(v => !groupValues.includes(v));
				}
			}

			// 如果当前选项已选中，则取消选中；否则添加选中
			if (isSelected) {
				// 取消选中
				const index = this.select.indexOf(value);
				if (index > -1) {
					this.select.splice(index, 1);
				}
			} else {
				// 添加选中
				this.select.push(value);
			}
		},
		// 重置筛选条件
		handleReset() {
			this.select = ['1','2','3', '5', '4', '8', '9', '10']
			this.$refs.popoverRef.hide();
			this.filterInput();
			this.search();
		},
		// 确认筛选
		handleConfirm() {
			this.$refs.popoverRef.hide();
			this.filterInput();
			this.search();
		},
		renderColoredText(text) {
			const redKeywords = ['二手', '过保', '包附破损'];
			let result = text;
			redKeywords.forEach(keyword => {
				const regex = new RegExp(keyword, 'g');
				result = result.replace(regex, `<span style="color: red;">${keyword}</span>`);
			});
			return result;
		},
		search() {
			if (!this.user_id) {
				this.$router.push('/login');
				return false
			}
			const selectStr = this.select ? this.select.join(',') : '';
			if (this.$route.path == '/search') {

				this.$emit("HeadIndexSearch", { filter: this.filter, stock_type: selectStr, });
			} else {
				this.$router.push({ path: '/search', query: { filter: this.filter, stock_type: selectStr, } });
			}


		},
	}
}
</script>
<style lang="less" scoped>
.el-dropdown {
	line-height: 40px;
}

.el-dropdown,
.el-dropdown * {
	border: none !important;
	outline: none !important;
	box-shadow: none !important;
}

.el-popover {
	width: 500px !important;
}

:deep(.el-dropdown-menu__item) {
	/* padding-left:25px;
	padding-right:25px; */
}

:deep(.filter-badge .el-badge__content.is-fixed) {
	top: 0px
}
:deep(.el-dropdown-link .el-badge__content.is-fixed) {
	top: 10px
}
:deep(.head .el-badge__content.is-fixed) {
	top: 10px
}

:deep(.Search .el-input__wrapper) {
	min-width: 150px;
}


/* 选中项父容器：仅保留 flex 横向布局，移除所有 overflow 样式 */
.no-wrap-select :deep(.is-near) {
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
	/* 核心：强制横向排列，不换行 */
	width: 100%;
	gap: 4px;
	/* 选中项之间的间距 */
	/* 完全移除 overflow 相关样式，避免任何内容被遮挡 */
	white-space: nowrap;
	overflow: hidden;
	/* 仅作用于标签内部，不影响外层容器 */
	text-overflow: ellipsis;
}













.ccc :deep(.el-scrollbar__wrap--hidden-default) {
	max-height: unset !important;
}

.el-scrollbar {
	max-height: unset !important;
	height: auto !important;
}



.ccc .el-select-dropdown__item {
	white-space: normal !important;
	word-break: break-all !important;
	height: auto !important;
}

.ccc .el-scrollbar__bar {
	display: none !important;
}

/* 全局样式 第五个分组 + 右下角手形 */
.ccc .el-select-group__wrap:nth-of-type(5) {
	position: absolute;
	right: 0px;
	bottom: 0px;
	background: #f5faff;

	.el-select-dropdown__item {
		padding: 0 1rem 0 1rem;
	}

	.is-selected::after {
		display: none
	}
}

/* 全局样式 第五个分组 + 右下角手形 */
.ccc .el-select-group__wrap:nth-of-type(6) {
	position: absolute;
	right: 60px;
	bottom: 0px;
	background: #f5faff;

	.el-select-dropdown__item {
		padding: 0 1rem 0 1rem;
	}

	.is-selected::after {
		display: none
	}
}

.ccc .el-select-group__wrap:nth-of-type(5)::after {}

/* 筛选弹窗样式 */
.filter-popover {
	width: 400px;
	padding: 16px;
	border-radius: 8px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.filter-content {
	width: 100%;
}

.filter-row {
	margin-bottom: 8px;
	border-bottom: 1px solid #f0f0f0;

	&:last-of-type {
		border-bottom: none;
		margin-bottom: 0;
		padding-bottom: 0;
	}
}

.filter-label {
	font-weight: 500;
	color: #606266;
	line-height: 32px;

	display: flex;
}

.filter-label span {
	display: inline-block;
	width: 60px;
	text-align: justify;
	-moz-text-align-last: justify;
	text-align-last: justify;
	margin-right: 0.25rem;
	flex-shrink: 0;
	text-justify: inter-character;
}

.filter-options {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.filter-btn {
	padding: 6px 8px;
	border-radius: 4px;
	font-size: 11px;
	transition: all 0.2s;
	margin-right: 0.3rem !important;
	margin-bottom: 0.3rem !important;

	&.el-button--primary {
		background-color: #ff8a5c;
		border-color: #ff8a5c;
		color: #fff;

	}

	&.el-button--default {
		background-color: transparent;
		border-color: transparent;
		color: #606266;

		&:hover {
			background-color: #f5f7fa;
			border-color: transparent;
		}
	}
}

.goods-type-select {
	width: 220px;
	flex-shrink: 0;
}

.goods-type-select :deep(.el-select__wrapper) {
	min-height: 32px;
	height: 32px;
}

.goods-type-select :deep(.el-select__tags) {
	flex-wrap: wrap;
}

.goods-type-select :deep(.el-select__selection) {
	flex-wrap: wrap;
}

.filter-actions {
	margin-top: 16px;
	padding-top: 16px;
	//border-top: 1px solid #f0f0f0;
}

.reset-btn {
	margin-right: 8px;
	color: #606266;
}

.confirm-btn {
	background-color: #ff8a5c;
	border-color: #ff8a5c;
}
</style>